import { fetch } from '../utils/fetch';

/**
 * 查询列表
 * @returns {Promise<Response>}
 */
export function _queryStorys(
  {
    page, size, direction, sort,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-story`,
    method: 'get',
    params: {
      page,
      size,
      direction,
      sort,
    },
  });
}

/**
 * 根据 id 查询
 * @returns {Promise<Response>}
 */
export function _queryStory(storyId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-story/${storyId}`,
    method: 'get',
  });
}

export function _addStory(
  {
    title,
    content,
    image,
    images,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-story`,
    method: 'post',
    data: {
      title,
      content,
      image,
      images,
    },
  })
}

export function _updateStory(storyId, {
  title,
  content,
  image,
  images, },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-story/${storyId}`,
    method: 'patch',
    data: {
      title,
      content,
      image,
      images,
    },
  })
}

export function _deleteStory(storyId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-story/${storyId}`,
    method: 'delete',
  })
}

export default {};
